export const RiotbarLocaleToPosixMap = {
    "en-us": "en_US",
    "zh-hk": "zh_HK",
    "en-sg": "en_SG",
    "en-gb": "en_GB",
    "en-au": "en_AU",
    "en-pl": "en_PL",
    "en-ph": "en_PH",
    "id-id": "id_ID",
    "ms-my": "ms_MY",
    "th-th": "th_TH",
    "zh-tw": "zh_TW",
    "vi-vn": "vi_VN",
    "ja-jp": "ja_JP",
    "ru-ru": "ru_RU",
    "es-mx": "es_MX",
    "tr-tr": "tr_TR",
    "it-it": "it_IT",
    "pl-pl": "pl_PL",
    "es-es": "es_ES",
    "fr-fr": "fr_FR",
    "ko-kr": "ko_KR",
    "pt-br": "pt_BR",
    "ar-ae": "ar_AE",
    "de-de": "de_DE",
    "cs-cz": "cs_CZ",
    "el-gr": "el_GR",
    "es-ar": "es_AR",
    "hu-hu": "hu_HU",
    "ro-ro": "ro_RO",
};
//# sourceMappingURL=localization.js.map